import { useAtomValue } from 'jotai';
import { useMatch } from 'react-router-dom';
import { exportContentAtom } from '@/atoms/exporting';
import { useQueryParam } from '@/hooks/useQueryParam';
import { ExportContent } from '@/types/exporting';
import { trackContentUploadDownloadEvent } from '../analytics';

const useExportContext = () => {
  const dataLockerMatch = useMatch('/:locale/data-locker/*');
  const isPlayerSection = useMatch('/:locale/player/*');
  const comparisonId = useQueryParam('comparisonId');

  const entity = isPlayerSection ? 'player' : 'team';
  const mode = comparisonId ? 'comparison' : 'single';
  const entityContext = `${entity} ${mode}`;
  const exportContext = dataLockerMatch ? 'data locker' : entityContext;

  return exportContext;
};

const useExportContentSubType = () => {
  const exportContent = useAtomValue(exportContentAtom);
  const isRadarPage = useMatch('/:locale/:entity/:entityId/radar/*');
  const visualisation = isRadarPage ? 'Radar' : 'Pitch';

  if (exportContent === ExportContent.TABLE) return 'Table';
  if (exportContent === ExportContent.VIS) return visualisation;
  if (exportContent === ExportContent.VIS_TABLE) return `${visualisation} & Table`;
  return visualisation;
};

export const useTrackVisExportEvent = () => {
  const context = useExportContext();
  const contentSubType = useExportContentSubType();

  const trackExportEvent = () =>
    trackContentUploadDownloadEvent({
      uploadVsDownload: 'Download',
      contentType: 'Visualization',
      contentSubType,
      context,
    });

  return { trackExportEvent };
};
